<template>
  <div id="home">
    <div>
      <div class="content">本平台暂不对外开放</div>
      <div class="content">更多功能，敬请期待</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'home',
    data () {

    }
  }
</script>

<style lang="stylus" scoped>
  #home {
    .content {
      margin-top: 100px;
      font-size: 64px;
      text-align: center;
      font-weight: bold;
      color: #999;
    }
  }
</style>
